var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCapturePhotoIdIncorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 150,
    viewBox: "0 0 194 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17573_25413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H184C189.523 0 194 4.47715 194 10V120C194 125.523 189.523 130 184 130H10C4.47715 130 0 125.523 0 120V10Z",
    fill: "#7A8189"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_17573_25413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 -1.66309H176V82.9997H18V-1.66309Z",
    fill: "url(#paint0_linear_17573_25413)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.257 30.2307C118.257 28.9496 119.393 27.9111 120.795 27.9111H165.847C167.249 27.9111 168.385 28.9496 168.385 30.2307V71.4023C168.385 72.6833 167.249 73.7218 165.847 73.7218H120.795C119.393 73.7218 118.257 72.6833 118.257 71.4023V30.2307Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.866 37.7285C137.503 30.9505 143.614 33.2371 146.491 35.5375C152.125 34.1134 157.175 39.0431 157.639 44.1918C158.478 53.5034 150.327 57.5567 155.242 61.0622C157.411 62.6093 160.969 63.9903 159.102 65.8909C158.132 66.8779 156.867 67.6046 155.601 68.1829C147.86 71.7201 138.279 70.4823 132.945 69.3879C130.17 68.8186 128.385 67.3446 127.325 65.6013C126.199 63.7504 129.736 61.9019 131.627 60.8432C135.343 58.7618 122.756 48.6834 131.866 37.7285Z",
    fill: "#AEBBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.78 58.542C139.86 59.5644 139.804 61.8065 138.941 62.5953C138.519 62.9813 137.453 63.401 136.118 63.9266C134.044 64.7433 131.32 65.8157 129.351 67.4154C126.762 69.5187 126.194 73.1119 126.234 73.6596H158.84C158.88 73.1119 158.312 69.5187 155.723 67.4154C153.754 65.8157 151.03 64.7433 148.956 63.9266C147.622 63.401 146.556 62.9813 146.133 62.5953C145.27 61.8065 145.214 59.5644 145.294 58.542H139.78Z",
    fill: "#AEBBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.533 68.8408C140.615 68.8408 136.66 68.6213 135.222 67.6357C134.334 67.0272 133.616 66.1034 133.109 65.1855C135.686 63.9959 138.229 63.2469 138.941 62.5957C139.804 61.8066 139.86 59.5643 139.78 58.542H142.533V68.8408ZM145.294 58.542C145.214 59.5644 145.27 61.8069 146.133 62.5957C146.845 63.2464 149.384 63.9954 151.959 65.1836C151.453 66.102 150.734 67.0268 149.846 67.6357C148.407 68.6211 144.452 68.8408 142.534 68.8408V58.542H145.294Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.734 52.3346C151.583 56.7963 147.721 60.9525 143.135 60.9525C138.567 60.9525 134.718 56.8226 133.55 52.3883C133.47 52.4012 133.388 52.4078 133.305 52.4078C132.18 52.4078 131.268 51.1817 131.268 49.6691C131.268 48.1566 132.18 46.9304 133.305 46.9304C133.37 46.9304 133.433 46.9344 133.496 46.9422C134.597 42.4003 138.495 39.043 143.135 39.043C147.791 39.043 151.7 42.4231 152.785 46.9885C152.92 46.9504 153.061 46.9304 153.204 46.9304C154.33 46.9304 155.242 48.1566 155.242 49.6691C155.242 51.1817 154.33 52.4078 153.204 52.4078C153.043 52.4078 152.885 52.3825 152.734 52.3346Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.541 46.7114C142.693 45.7567 145.052 43.8455 145.771 42.0197C146.131 43.1152 147.64 45.0931 149.248 46.073C151.405 47.3875 153.084 47.0589 154.882 46.8398C155.441 46.4746 155.817 45.1966 154.282 42.5674C152.364 39.281 148.648 38.8428 143.254 38.4046C138.939 38.0541 133.824 42.677 131.866 44.8679C131.706 45.1601 130.188 47.6973 136.541 46.7114Z",
    fill: "#AEBBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9805 9.35449H27.0817V16.5501H24.9805V9.35449Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1828 9.35449H31.284V16.5501H29.1828V9.35449Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3852 9.35449H35.4864V16.5501H33.3852V9.35449Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5876 9.35449H39.6887V16.5501H37.5876V9.35449Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7899 9.35449H43.8911V16.5501H41.7899V9.35449Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9923 9.35449H48.0935V16.5501H45.9923V9.35449Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1946 9.35449H52.2958V16.5501H50.1946V9.35449Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.397 9.35449H56.4982V16.5501H54.397V9.35449Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3658 63.7712H45.467V70.9668H43.3658V63.7712Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5682 63.7712H49.6694V70.9668H47.5682V63.7712Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7705 63.7712H53.8717V70.9668H51.7705V63.7712Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9729 63.7712H58.0741V70.9668H55.9729V63.7712Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1753 63.7712H62.2764V70.9668H60.1753V63.7712Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3776 63.7712H66.4788V70.9668H64.3776V63.7712Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.58 63.7712H70.6812V70.9668H68.58V63.7712Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7823 63.7712H74.8835V70.9668H72.7823V63.7712Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5606 63.7712H80.6618V70.9668H78.5606V63.7712Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.763 63.7712H84.8641V70.9668H82.763V63.7712Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9653 63.7712H89.0665V70.9668H86.9653V63.7712Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1677 63.7712H93.2689V70.9668H91.1677V63.7712Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.37 63.7712H97.4712V70.9668H95.37V63.7712Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5724 63.7712H101.674V70.9668H99.5724V63.7712Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9805 29.5921H37.258V39.9358H24.9805V29.5921Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3273 29.5921H43.3967V39.9358H40.3273V29.5921Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4661 29.5921H49.5355V39.9358H46.4661V29.5921Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6048 29.5921H59.1272V39.9358H52.6048V29.5921Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1966 29.5921H65.266V39.9358H62.1966V29.5921Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3354 29.5921H71.4047V39.9358H68.3354V29.5921Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4741 29.5921H97.1107V39.9358H74.4741V29.5921Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.18 29.5921H103.249V39.9358H100.18V29.5921Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9805 43.9833H37.258V54.327H24.9805V43.9833Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3273 43.9833H43.3967V54.327H40.3273V43.9833Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4661 43.9833H49.5355V54.327H46.4661V43.9833Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6048 43.9833H59.1272V54.327H52.6048V43.9833Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1966 43.9833H65.266V54.327H62.1966V43.9833Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3354 43.9833H71.4047V54.327H68.3354V43.9833Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0547 9.35449H70.1559V16.5501H68.0547V9.35449Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2571 9.35449H74.3582V16.5501H72.2571V9.35449Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4594 9.35449H78.5606V16.5501H76.4594V9.35449Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6618 9.35449H82.763V16.5501H80.6618V9.35449Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8641 9.35449H86.9653V16.5501H84.8641V9.35449Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0665 9.35449H91.1677V16.5501H89.0665V9.35449Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2689 9.35449H95.37V16.5501H93.2689V9.35449Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4712 9.35449H99.5724V16.5501H97.4712V9.35449Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.868 9.35449H138.97V16.5501H136.868V9.35449Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.071 9.35449H143.172V16.5501H141.071V9.35449Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.273 9.35449H147.374V16.5501H145.273V9.35449Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.475 9.35449H151.577V16.5501H149.475V9.35449Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.678 9.35449H155.779V16.5501H153.678V9.35449Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.88 9.35449H159.981V16.5501H157.88V9.35449Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.083 9.35449H164.184V16.5501H162.083V9.35449Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.285 9.35449H168.386V16.5501H166.285V9.35449Z",
    fill: "#EBF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0623 67.9031C37.0623 71.1164 34.3577 73.7214 31.0214 73.7214C27.6851 73.7214 24.9805 71.1164 24.9805 67.9031C24.9805 64.6897 27.6851 62.0847 31.0214 62.0847C34.3577 62.0847 37.0623 64.6897 37.0623 67.9031Z",
    fill: "#EBF4F9"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: -14.5,
    width: 157,
    height: 97,
    rx: 4.5,
    stroke: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_17573_25413)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 110,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EC515A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 120L87 140M107 140L87 120",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17573_25413",
    x1: 166.746,
    y1: -7.87197,
    x2: 12.843,
    y2: 89.2963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4DFE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6BFC5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17573_25413"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H184C189.523 0 194 4.47715 194 10V120C194 125.523 189.523 130 184 130H10C4.47715 130 0 125.523 0 120V10Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_17573_25413"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: -15,
    width: 158,
    height: 98,
    rx: 5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_17573_25413"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 110,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapturePhotoIdIncorrect);
export default __webpack_public_path__ + "static/media/capture-photo-id-incorrect.9d99d00ae89a75257b8f406220de416b.svg";
export { ForwardRef as ReactComponent };